export const PROFILE_DROPDOWN_TYPE = {
	DEFAULT: "default",
	CURRENCY: "currency",
	LANGUAGE: "language",
};